/*******************************************************************************
CHANGE TIME PERIOD
Navigates to the desired URL.
*******************************************************************************/

export default function changeTimePeriod(url) {
    if (url) {
        window.location.href = url;
    }
}
